import moment from "moment";

export const capitalizeFLetter = (string) => {
  if (string) {
    return string[0].toUpperCase() + string.slice(1);
  }
  return string;
};

export const getStaticImg = (dir) => {
  return `/assets/img/${dir}`;
};
export const scrollTo = (
  id,
  idSec,
  headerOffsetVal = 0,
  behavior = "smooth"
) => {
  let ref = document?.getElementById(id) || document?.getElementById(idSec);
  function scrollToTargetAdjusted() {
    let element = ref;
    let headerOffset = headerOffsetVal;
    let elementPosition = element.getBoundingClientRect().top;
    let offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: behavior,
    });
  }
  setTimeout(function () {
    if (ref) {
      ref?.scrollIntoView({
        behavior: behavior,
        block: "start",
      });
      headerOffsetVal && scrollToTargetAdjusted();
    } else {
      window.scrollTo({ top: 0, behavior: behavior });
    }
  }, 100);
};

export const isLiveStreamingDate = () => {
  const date1 = moment();
  const date2 = "06-11-2022 06:00";

  const format = "DD-MM-YYYY HH:mm";
  const result = moment(date1, format).isAfter(moment(date2, format));

  //return true when date1 greater than date2
  //return result;
  return false;
};
export default {
  getStaticImg,
  scrollTo,
  isLiveStreamingDate,
};

export const GetPathName = ({ path, numberPath = 0 }) => {
  const pathName = path[numberPath];
  let eventName = "Homepage";
  switch (pathName) {
    case "info-lokasi":
      eventName = "Location";
      break;
    case "klasemen-pertandingan":
      eventName = "Standings";
      break;
    case "jadwal-pertandingan":
      eventName = "Match";
      break;
    default:
      break;
  }
  return { pathName, eventName };
};

export const formatRupiah = (amount) => {
  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
  })
    .format(amount)
    .replace(/\s/g, ""); // Remov;
};

export const generateCardType = (data) => {
  const currentDay = moment();

  const {
    eventStartDate,
    eventEndDate,
    registrationStartDate,
    registrationEndDate,
    videoUrl,
  } = data;

  const withinRegistrationDate = moment(currentDay)?.isBetween(
    registrationStartDate,
    registrationEndDate,
    "day",
    "[]"
  );
  const withinEventDate = moment(currentDay)?.isBetween(
    eventStartDate,
    eventEndDate,
    "day",
    "[]"
  );
  const isBeforeRegistrationPeriod = moment(currentDay)?.isBefore(
    registrationStartDate,
    "day"
  );
  const isAfterRegistrationPeriod = moment(currentDay)?.isAfter(
    registrationEndDate,
    "day"
  );
  const isBeforeEventEndDate = moment(currentDay)?.isBefore(
    eventEndDate,
    "day"
  );

  /**
   * Upcoming Condition:
   * 1. Before registration period`
   * 2. Not within registration date range
   * 3. Not within event date range
   * 4. No video url
   */
  if (
    isBeforeRegistrationPeriod &&
    !withinRegistrationDate &&
    !withinEventDate
  ) {
    return "upcoming";
  }

  /**
   * Before Event In Registration Period
   * 1. Within registration date range
   * 2. No video URL
   */
  if (withinRegistrationDate) {
    return "before_event_in_registration_period";
  }

  /**
   * Before Event Not In Registration Period
   * 1. After registration period
   * 2. Not within registration date range
   * 3. Not within event date range
   * 4. No Video Url
   * 5. Before event end date
   */
  if (
    isAfterRegistrationPeriod &&
    !withinRegistrationDate &&
    !withinEventDate &&
    isBeforeEventEndDate
  ) {
    return "before_event_not_in_registration_period";
  }

  /**
   * Event Day
   * 1. Within event date range
   * 2. Not within registration date
   * 3. No video url
   * 4.
   */
  if (withinEventDate && !withinRegistrationDate && !videoUrl) {
    return "event_day_without_video_url";
  }

  /**
   * Event Day Final
   * 1. Within event date range
   * 2. Not within registration date
   * 3. Have video url
   */
  if (withinEventDate && !withinRegistrationDate && videoUrl) {
    return "event_day_with_video_url";
  }

  /**
   * pas Event
   * 1. Past event
   * 2. Not within registration date
   * 3. Not within event date range
   */
  return "past_event";
};
